export default {
  namespaced: true,
  actions: {
    create({ commit }, workRight) {
      return Vue.$http.post('candidate/work_rights', { workRight })
    },
    destroy({ commit }, id) {
      return Vue.$http.delete(`candidate/work_rights/${id}`)
    }
  }
}
